module.exports = __webpack_public_path__ + "static/media/29BDOS23.559d59a4.jpg";